import BillSummaryChart from "./BillSummaryChart"

const BillSummaryCard = () => {
    return (
        <div className="">
            <BillSummaryChart />
        </div>
    )
}

export default BillSummaryCard